export const DEFAULT_ACTION = "app/AddNewInvoice/DEFAULT_ACTION";
export const FORMDATA = "app/AddNewInvoice/BLOCKDATA";
export const SETFORMDATA = "app/AddNewInvoice/BLOCKDATA/SET/VALUE";
export const SETVALUEFETCH = "app/AddNewInvoice/BLOCKDATA/SETVALUEFETCH";
